import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {Row} from "reactstrap";

const OtherEmailsRadio = ({customer=null}) => {

    const authUser = useSelector(({auth}) => auth.authUser);
    // const {loadingAddTag, loadingAddTagError, loadingUpdateTag, loadingUpdateTagError} = useSelector(({breachrisk})=> breachrisk);

    const isDisabled = true;
    const textColor = isDisabled ? "text-light-gray" : "";
    const otherEmailsTags = bbFindUserTagsByTagId(authUser, 16);


    const handleOnClick = (value) => {
        setSelected(value)
    }

    const [selected, setSelected] = useState(otherEmailsTags
        && otherEmailsTags.length > 0
        && otherEmailsTags[0]
        && otherEmailsTags[0].definition
        && otherEmailsTags[0].definition.description
            ? otherEmailsTags[0].definition.description : "neither");

    return(
        <Row>
            <p className={`col-11 text-center ${textColor}`}>
                Would you like to receive emails regarding marketing materials or request for feedback?
            </p>
            {isDisabled && <ComingSoonIconSettings/>}
            {/*<p className={"col-1"}> </p>*/}
            <p className={"col-11 text-center"}>
            <form className={`m-0 p-0 d-inline ${textColor}`}>
                <div className={"col-6 d-inline m-0 p-0"}>
                    <input type="radio"
                           id="both"
                           name={"emails"}
                           value={"both"}
                           checked={selected === "both"}
                           disabled
                           onClick={(e)=>handleOnClick(e.target.value)}
                    />
                    <label htmlFor="darkMode">&nbsp; Marketing and Feedback Emails</label>
                </div>
                <div className={"col-6 d-inline"}>
                    <input type="radio"
                           id="marketing"
                           name={"emails"}
                           value={"marketing"}
                           checked={selected === "marketing"}
                           disabled
                           onClick={(e)=>handleOnClick(e.target.value)}
                    />
                    <label htmlFor="lightMode">&nbsp; Marketing</label>
                </div>
                <div className={"col-6 d-inline m-0 p-0"}>
                    <input type="radio"
                           id="feedback"
                           name={"emails"}
                           value={"feedback"}
                           checked={selected === "feedback"}
                           disabled
                           onClick={(e)=>handleOnClick(e.target.value)}
                    />
                    <label htmlFor="darkMode">&nbsp; Feedback &nbsp;</label>
                </div>
                <div className={"col-6 d-inline m-0 p-0"}>
                    <input type="radio"
                           id="neither"
                           name={"emails"}
                           value={"neither"}
                           checked={selected === "neither"}
                           disabled
                           onClick={(e)=>handleOnClick(e.target.value)}
                    />
                    <label htmlFor="darkMode">&nbsp; Neither</label>
                </div>
            </form>
            </p>
        </Row>

    )
}

export default OtherEmailsRadio;